<div *ngIf="mode === 'lite'" class="vehicle-list-filter-container vehicle-list-filter-container--lite bg-white" #filterBlock>

  <!-- <div class="tagging">
    <tk-tag-picker [selectedTags]="form.controls['Tags'].value" [tagType]="0"
                   (onSelectedTags)="handleOnSelectedTags($event)" (onHeightChanged)="handleOnHeightChanged($event)">
    </tk-tag-picker>
  </div> -->

  <div class="searching" [ngClass]="{'input-has-focus' : inputHasFocus}">
    <div class="search-input">
      <tk-search 
        [control]="form.controls['Phrase']"
        [loading]="loading"
        (onEnterEvent)="onSearchEnter()"
        (onClearEvent)="onClearEnter()"
        (onFocusEvent)="onInputFocus($event)"
      ></tk-search>
    </div>

    <tk-select class="dropdown-third" [onlyValue]="true" [formControl]="$any(form.controls['Field'])" [options]="fieldTypes">
      <ng-template #itemTemplate let-item="$implicit">
        <span *ngIf="item">{{ item.label }}</span>
      </ng-template>
    </tk-select>
  </div>

  <div class="dropdowns">
    <ng-container *ngIf="isTacho">
      <app-filter-control
        *ngIf="filtersStatusTachoConfig"
        (onSubmitFilters$)="onSubmitFilters($event, filtersStatusTachoConfig)"
        [data]="filtersStatusTachoConfig"
        [optionsSelectedCount]="(tachoFilters?.selectedStatus !== null) ? 1 : 0"
      ></app-filter-control>
    </ng-container>

    <ng-container *ngIf="!isTacho">
      <app-filter-control
        *ngIf="filtersStatusConfig"
        [selectedControlValue]="filtersStatusCurrentFilters"
        (onSubmitFilters$)="onSubmitFilters($event, filtersStatusConfig)"
        [data]="filtersStatusConfig"
        [optionsSelectedCount]="(form.controls['Status'].value) ? 1 : 0"
      ></app-filter-control>
    </ng-container>

    <app-filter-control
      *ngIf="filtersGroupConfig"
      [selectedControlValue]="filtersGroupCurrentFilters"
      (onSubmitFilters$)="onSubmitFilters($event, filtersGroupConfig)"
      [data]="filtersGroupConfig"
      [optionsSelectedCount]="form.controls['Tags'].value?.length"
      [isVisibleSearchInput]="true"
    ></app-filter-control>
    <app-filter-control
      *ngIf="filtersLockConfig && isVisibleLockFilter"
      [selectedControlValue]="filtersLockCurrentFilters"
      (onSubmitFilters$)="onSubmitFilters($event, filtersLockConfig)"
      [data]="filtersLockConfig"
      [optionsSelectedCount]="(form.controls['IgnitionBlockerState'].value) ? 1 : 0"
    ></app-filter-control>

    <button
      *ngIf="form.controls['Tags'].value?.length || form.controls['Status'].value || form.controls['Phrase'].value?.length" 
      (click)="clearAllFilters()"
      class="clear-filters"
    >
      {{ 'labels.clear' | translate }}
    </button>
    <!-- {{ form.controls['Tags'].value | json }} -->
    <!-- <tk-select class="dropdown-status" [onlyValue]="true" [formControl]="$any(form.controls['Status'])"
               [options]="vehicleStatuses">
      <ng-template #itemTemplate let-item="$implicit">
        <div class="dropdown-status-item-container">
          <div *ngIf="item.data" class="dropdown-status__count dropdown-status__count--{{item.value}}">
            <span>{{ item.data.count }}</span>
          </div>
          <span class="dropdown-status__label_text">{{ item.label }}</span>
        </div>
      </ng-template>
    </tk-select> -->

    <!-- <tk-select class="dropdown-display-field" [onlyValue]="true" [formControl]="displayFieldControl"
               [options]="vehicleIndicatorTypes">
      <ng-template #itemTemplate let-item="$implicit">
        <span *ngIf="item">{{ item.label }}</span>
      </ng-template>
    </tk-select> -->
  </div>

</div>


<div *ngIf="mode === 'full'" class="vehicle-list-filter-container vehicle-list-filter-container--full" #filterBlock>

  <div class="searching" [ngClass]="{'input-has-focus' : inputHasFocus}">
    <div class="search-input">
      <tk-search [control]="form.controls['Phrase']" [loading]="loading" (onEnterEvent)="onSearchEnter()"
                 (onClearEvent)="onSearchClear()" (onFocusEvent)="onInputFocus($event)"></tk-search>
    </div>


    <tk-select class="dropdown-third" [onlyValue]="true" [formControl]="$any(form.controls['Field'])"
               [options]="fieldTypes">
      <ng-template #itemTemplate let-item="$implicit">
        <span *ngIf="item">{{ item.label }}</span>
      </ng-template>
    </tk-select>

  </div>

  <div class="dropdowns">
    <tk-select class="dropdown-status" [onlyValue]="true" [formControl]="$any(form.controls['Status'])"
               [options]="vehicleStatuses">
      <ng-template #itemTemplate let-item="$implicit">
        <div class="dropdown-status-item-container">
          <div *ngIf="item.data" class="dropdown-status__count dropdown-status__count--{{item.value}}">
            <span>{{ item.data.count }}</span>
          </div>
          <span class="dropdown-status__label_text">{{ item.label }}</span>
        </div>
      </ng-template>
    </tk-select>
  </div>

  <div *ngIf="form != null" class="tagging">
    <tk-tag-picker
      [selectedTags]="form.controls['Tags'].value"
      [tagType]="0"
      (onSelectedTags)="handleOnSelectedTags($event)"
      mode="full"
    ></tk-tag-picker>
  </div>

</div>
